import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { cartPayment } from "../../utils/cartPayment"; // Adjust the path as needed
import { IoCheckmark } from "react-icons/io5";
import { quotetPayment } from "../../utils/quotePayment";

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const txnId = query.get("txnid");

  // State variables for API response details and error messages
  const [paymentDetails, setPaymentDetails] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    const storedCartPayment = localStorage.getItem("cartPaymentData");
    const quotePayment = localStorage.getItem("quotePaymentData");
    if (storedCartPayment) {
      const paymentData = JSON.parse(storedCartPayment);
      const formData = {
        email: paymentData.email,
        productIds: paymentData.productIds,
        totalPrice: paymentData.amount,
        discountCoupon: paymentData.discountCoupon || "",
        transationId: txnId,
      };
      cartPayment(formData)
        .then((data) => {
          setPaymentDetails(paymentData);
          console.log(data, "data");
          // Remove payment data from local storage after successful API call
          localStorage.removeItem("cartPaymentData");
          localStorage.removeItem("quotePaymentData");
        })
        .catch((err) => {
          console.error("Payment API call failed: ", err);
          setError("Payment API call failed");
        });
    }
    if (quotePayment) {
      const paymentData = JSON.parse(quotePayment);
      const formData = {
        quoteId: paymentData.quotationNumber,
        productIds: paymentData.productIds,
        totalPrice: paymentData.amount,
        quoteStatus: "1",
        discountCode: paymentData.discountCoupon || "",
        transactionNumber: txnId,
      };
      quotetPayment(formData)
        .then((data) => {
          setPaymentDetails(paymentData);
          console.log(data, "data");
          // Remove payment data from local storage after successful API call
          localStorage.removeItem("cartPaymentData");
          localStorage.removeItem("quotePaymentData");
        })
        .catch((err) => {
          console.error("Payment API call failed: ", err);
          setError("Payment API call failed");
        });
    }
  }, [txnId]);

  // Redirect after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/products/orders");
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="p-8 flex justify-center h-screen flex-col items-center">
      <div className="bg-green-200 w-24 h-24 rounded-full flex justify-center items-center">
        <IoCheckmark className="text-5xl text-green-600 font-bold" />
      </div>
      <div className="mt-5 text-center">
        <h1 className="text-3xl font-semibold mb-4">Payment Successful</h1>
        <p className="mb-2">
          <span className="font-semibold">User Name:</span>{" "}
          {paymentDetails.firstName}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Transaction ID:</span> {txnId}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Amount:</span> {paymentDetails.amount}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Product Info:</span>{" "}
          {paymentDetails.productInfo}
        </p>
        {paymentDetails.quoteId && (
          <p className="mb-2">
            <span className="font-semibold">QuoteNo:</span>{" "}
            {paymentDetails.quoteNo || "Success"}
          </p>
        )}
        {paymentDetails.message && (
          <p className="mb-2">
            <span className="font-semibold">Message:</span>{" "}
            {paymentDetails.message}
          </p>
        )}
        {error && <p className="text-red-500 mb-2">{error}</p>}
      </div>
    </div>
  );
};

export default PaymentSuccess;
